// This list is NOT complete and only has the needed values
// TODO: add more as needed
export const InputPaths = {
  CustodialMinorInformation: "CustodialMinorInformation",
  JointAccountInformation: "JointAccountInformation",
  PersonalInformation: "PersonalInformation",
};
